import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalRequestDetailsBaseComponent } from '../_modal-request-details-base/modal-request-details-base.component';
import { BehaviorSubject } from 'rxjs';
import { AccountRequisition, ReplyConfig, REQUEST_TYPE } from '../../_core/approvals-page.model';
import { ModalRequestActionsComponent } from '../_modal-request-actions/modal-request-actions.component';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { AlertComponent } from '../../../../../components/alert/alert.component';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'modal-account-details',
  standalone: true,
  imports: [CommonModule, ModalRequestActionsComponent, LocalLoaderComponent, AlertComponent, I18nModule],
  templateUrl: './modal-account-details.component.html',
  styleUrl: './modal-account-details.component.scss',
})
export class ModalAccountDetailsComponent extends ModalRequestDetailsBaseComponent implements OnInit {
  accountRequisition$ = new BehaviorSubject<AccountRequisition>({});
  replyConfig: ReplyConfig = {
    type: REQUEST_TYPE.ACCOUNT,
  };

  override ngOnInit(): void {
    super.ngOnInit();
    this.getAccountRequisition();
  }

  getAccountRequisition() {
    this.subscription.add(
      this.requisitionDetailsRequest$.subscribe(response => {
        this.accountRequisition$.next(response.accountRequest || {});
      }),
    );
  }
}
